var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0078 3.12509C30.0078 1.74231 28.8878 0.622063 27.5051 0.622063H19.3707C17.9879 0.622063 16.8678 1.74231 16.8678 3.12509V13.1366C16.8678 14.5194 17.9879 15.6395 19.3707 15.6395H23.3878C24.0826 15.6395 24.6392 16.2026 24.6392 16.8908C24.6392 17.1161 24.583 17.2725 24.583 17.2725C23.6695 20.3012 21.3609 22.7289 18.4011 23.805L18.3887 23.8175C17.4936 24.1991 16.8678 25.0878 16.8678 26.1204C16.8678 27.5031 17.9879 28.6232 19.3708 28.6232C19.7087 28.6232 20.0275 28.5544 20.3215 28.4356L20.4347 28.3916C26.0348 26.208 30.0078 20.7641 30.0078 14.3881V3.12509ZM13.739 3.12509C13.739 1.74231 12.6191 0.622063 11.2362 0.622063H3.10181C1.71903 0.622063 0.599062 1.74231 0.599062 3.12509V13.1366C0.599062 14.5194 1.71903 15.6395 3.10181 15.6395H7.11902C7.81378 15.6395 8.37033 16.2026 8.37033 16.8908C8.37033 17.1224 8.31433 17.2725 8.31433 17.2725C7.40063 20.3012 5.0921 22.7289 2.13218 23.805L2.11979 23.8175C1.22482 24.1991 0.599062 25.0878 0.599062 26.1204C0.599062 27.5031 1.71903 28.6232 3.10181 28.6232C3.43969 28.6232 3.7587 28.5544 4.05257 28.4356L4.16579 28.3916C9.76605 26.208 13.739 20.7641 13.739 14.3881V3.12509Z",
    fill: "#0C3899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.a4df824a00f60e3c81ccc76e80af9ed7.svg";
export { ForwardRef as ReactComponent };